import { useQuery } from '@tanstack/react-query';

import { Membership, MEMBERSHIP_STATUS } from 'src/features/users/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `/parkings/:parkingId/memberships/`;

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    parkingId: string;
    user__is_staff?: boolean;
    status?: MEMBERSHIP_STATUS;
}
const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<Membership>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_PARKING_MEMBERSHIPS_RESOURCE, useQueryHook as useListParkingMemberships };
